import React, { useCallback } from 'react';
import { Route, Switch, useHistory, useRouteMatch } from 'react-router-dom';

import { Breadcrumbs } from '../../common/components/navigation';

import PatrolList from './list/PatrolList';
import PatrolSummary from './details/PatrolSummary';
import { useFindingContext } from '../../finding/contexts/findingContext';

const PatrolPage = () => {
  const { setClickedFinding } = useFindingContext();

  const history = useHistory();
  const { path, url } = useRouteMatch();

  const returnToList = useCallback(() => {
    history.push(url);
  }, [history, url]);

  const handleBackClick = useCallback(() => {
    setClickedFinding(undefined);
    returnToList();
  }, [returnToList, setClickedFinding]);

  const handleRowClick = useCallback(
    ({ id }) => {
      history.push(`${url}/${id}`);
    },
    [history, url]
  );

  return (
    <>
      <Breadcrumbs entityType="patrol" />

      <Switch>
        <Route strict path={`${path}/:id`}>
          <PatrolSummary onBackClick={handleBackClick} />
        </Route>

        <Route strict path={`${path}`}>
          <PatrolList onRowClick={handleRowClick} />
        </Route>
      </Switch>
    </>
  );
};

export default React.memo(PatrolPage);
